import type { PopoverActions } from '@mui/material';
import { ListItemIcon, ListItemText } from '@mui/material';
import type { ReactNode } from 'react';
import { Children, useEffect, useRef, useState } from 'react';
import { GroupItemMenu } from './GroupItemMenu';
import { GroupItemTrigger } from './GroupItemTrigger';

interface Props {
  expanded: boolean;
  icon: ReactNode;
  title: string;
  menuContent: ReactNode;
}

export function GroupItem({ expanded, icon, title, menuContent }: Props) {
  const actionRef = useRef<PopoverActions>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (Children.count(menuContent) === 0) {
      return;
    }

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleTransitionEnd = () => {
    actionRef.current?.updatePosition();
  };

  useEffect(() => {
    if (!expanded) {
      handleClose();
    }
  }, [expanded]);

  return (
    <>
      <GroupItemTrigger
        expanded={expanded}
        onTransitionEnd={handleTransitionEnd}
        onClick={handleOpen}
      >
        <ListItemIcon sx={{ width: 24, height: 24 }}>{icon}</ListItemIcon>
        <ListItemText
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          disableTypography
          primary={title}
        />
      </GroupItemTrigger>
      <GroupItemMenu
        actionRef={actionRef}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        {menuContent}
      </GroupItemMenu>
    </>
  );
}
